const required = value => (value ? undefined : "Este campo é requerido.");

const minLength = min => value => {
  if (value.replace(/\W/g, "").length >= min) {
    return undefined;
  }

  return `Este campo requer no mínimo ${min} caracteres.`;
};

const validNumericField = fieldSize => value => {
  return value.replace(/\D/g, "").length >= fieldSize;
};

const maxLength = max => value => {
  if (value.replace(/\W/g, "").length <= max) {
    return undefined;
  }

  return `Este campo requer no máximo ${max} caracteres.`;
};

const minMaxDay = value => {
  if (parseInt(value, 10) === 0 || parseInt(value, 10) > 31) {
    return "Este campo requer um valor entre 01 e 31 para dia.";
  }

  return undefined;
};

const minMaxMonth = value => {
  if (parseInt(value, 10) === 0 || parseInt(value, 10) > 12) {
    return "Este campo requer um valor entre 01 e 12 para mês.";
  }

  return undefined;
};

const minMaxDate = value => {
  const [month, year] = value.split("/");
  const result = minMaxMonth(month);

  if (result !== undefined) {
    return result;
  }
  const currentDate = new Date();
  const expirationDate = new Date(`20${year}`, month, 0);

  return expirationDate < currentDate
    ? "Este campo requer um valor maior ou igual à data atual."
    : undefined;
};

const validateCPF = value => {
  const errorMessage = "CPF inválido.";
  let numbers;
  let digits;
  let sum;
  let result;
  let equalChar = 1;

  const cpf = value.replace(/\D/g, "");

  if (cpf.length < 11) return errorMessage;

  for (let i = 0; i < cpf.length - 1; i += 1) {
    if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
      equalChar = 0;
      break;
    }
  }

  if (!equalChar) {
    numbers = cpf.substring(0, 9);
    digits = cpf.substring(9);
    sum = 0;
    for (let i = 10; i > 1; i -= 1) sum += numbers.charAt(10 - i) * i;
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (`${result}` !== digits.charAt(0)) return errorMessage;
    numbers = cpf.substring(0, 10);
    sum = 0;
    for (let i = 11; i > 1; i -= 1) sum += numbers.charAt(11 - i) * i;
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (`${result}` !== digits.charAt(1)) return errorMessage;

    return undefined;
  }

  return errorMessage;
};

const isValidCpf = cpf => {
  const errorMessage = validateCPF(cpf);
  if (errorMessage) return false;
  return true;
};

const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export {
  required,
  minLength,
  validNumericField,
  maxLength,
  minMaxDay,
  minMaxMonth,
  minMaxDate,
  composeValidators,
  validateCPF,
  isValidCpf,
};
